import React from 'react';
import ProposalSectionColumnsField from './ProposalSectionColumnsField';
import { useSelectedItemProps } from './useSelectedItemProps';

/** Champ Puck — layout colonnes (% + ajout / suppression). */
export function puckProposalSectionColumnsField(label = 'Colonnes') {
  return {
    type: 'custom',
    label,
    render: ({ onChange }) => (
      <ProposalSectionColumnsField onChange={onChange} />
    ),
  };
}

/** Réglage fin des colonnes, des espacements et de l'empilement. Ce champ n'a
 *  pas de prop à lui (Puck : un champ par prop, et `sectionColumns` a déjà la
 *  galerie) : il écrit `sectionColumns` par dispatch. */
function SectionColumnsSettings() {
  const { updateItemProps } = useSelectedItemProps();
  return (
    <ProposalSectionColumnsField
      part="advanced"
      onChange={(sectionColumns) => updateItemProps({ sectionColumns })}
    />
  );
}

export function puckSectionColumnsSettingsField(label = 'Colonnes') {
  return {
    type: 'custom',
    label,
    render: () => <SectionColumnsSettings />,
  };
}
